import React from 'react'

import BulkImport from './bulk-import'

const WebinarRegistrationsImport = () => {
  return (
    <div>
      <BulkImport
        title={
          <span>
            Import Webinar Registrations
          </span>
        }
        uploadPath='admin/webinars/registrations_import'
        templatePath='admin/webinars/registrations_import/template'
      >
        Import webinar registrations, this process will look up the webinar by ID
        then add the registrations for that webinar.
        <ul>
          <li>The system will match users by user ID or email address.</li>
          <li>If unregistering a user, enter "true" for registered to allow the upload.</li>
          <li>If a registration date is provided, it will set that date as the registration date. Otherwise, the current date will be used.</li>
          <li>All dates must be in ISO-8601 date format e.g. <code>2022-08-09T12:50:00-04:00</code></li>
        </ul>
      </BulkImport>
    </div>
  )
}

export default WebinarRegistrationsImport
